import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

type DatadogUser = {
  id: number | string;
  email?: string | null;
  name?: string | null;
  organization?: string | { name?: string | null } | null;
};

function normalizeDatadogUser(user: DatadogUser) {
  const organization =
    typeof user.organization === "string" ? user.organization : user.organization?.name;

  return {
    id: String(user.id),
    ...(user.email ? { email: user.email } : {}),
    ...((user.name ?? user.email) ? { name: user.name ?? user.email ?? undefined } : {}),
    ...(organization ? { organization } : {}),
  };
}

export function setDatadogUser(user?: DatadogUser | null) {
  if (!user?.id) {
    return;
  }

  const datadogUser = normalizeDatadogUser(user);

  try {
    datadogRum.setUser(datadogUser);
    datadogLogs.setUser(datadogUser);
  } catch {
    // Datadog can be unavailable during bootstrap/logout transitions.
  }
}

export function clearDatadogUser() {
  try {
    datadogRum.clearUser();
    datadogLogs.clearUser();
  } catch {
    // Datadog can be unavailable during bootstrap/logout transitions.
  }
}
